import { ChangeDetectionStrategy, Component, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-editor-switcher',
  templateUrl: './editor-switcher.component.html',
  styleUrl: './editor-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class EditorSwitcherComponent {
  readonly selectedValue = model('editor');

  readonly editorSwitcherChange = output<string>();

  onEditorChange(value: string) {
    if (this.selectedValue() === value) {
      return; // Prevent unnecessary updates if clicking the same option
    }
    
    this.selectedValue.set(value);
    this.editorSwitcherChange.emit(value);
  }
}
